import { useNavigate } from 'react-router-dom'
import { Box, Typography, Button, useMediaQuery } from '@mui/material'
import theme from 'lib/theme'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ProductsSearchBar } from './ProductsSearchBar'

export const ProductsHeader = ({
  handleSearch,
  query,
  hasListItems,
}: {
  handleSearch: (key: string, query: string | undefined) => void
  query: string | undefined
  hasListItems: boolean
}) => {
  const navigate = useNavigate()
  const [input, setInput] = useState<string>('')
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { t } = useTranslation()

  const clearSearch = () => {
    setInput('')
    navigate('/product')
  }
  return (
    <Box>
      <Box
        display='flex'
        justifyContent='space-between'
        sx={{
          [theme.breakpoints.between('xs', 'sm')]: {
            flexDirection: 'column',
          },
        }}>
        <Typography variant='h1' mb={3}>
          {t('product')}
        </Typography>
        <Box display='flex'>
          <ProductsSearchBar
            input={input}
            setInput={setInput}
            placeholderText={t('products.searchProductsPlaceholder')}
            handleClick={handleSearch}
            ariaLabel={t('products.searchProductsPlaceholder')}
            width={isMobile ? '70vw' : ' 300px'}
          />
        </Box>
      </Box>
      {query && (
        <Box>
          <Box>
            <Button
              onClick={clearSearch}
              sx={{
                background: 'transparent',
                color: theme.palette.primary.main,
                padding: 0,
                marginBottom: theme.spacing(1),
                '&:hover': {
                  background: 'transparent',
                  color: theme.palette.primary.dark,
                },
              }}>
              <ArrowBackIcon
                sx={{
                  fill: theme.palette.primary.main,
                  marginRight: theme.spacing(1),
                  '&:hover': { fill: theme.palette.primary.dark },
                }}
              />
              <Typography>{t('allProducts')}</Typography>
            </Button>
            {hasListItems ? (
              <Box display='flex'>
                <Typography
                  variant='h2'
                  sx={{ marginBottom: theme.spacing(1) }}>
                  {t('searchResults')}
                </Typography>
                <Typography variant='h2' sx={{ fontWeight: 'bold' }}>
                  &nbsp;&quot;{query}&quot;
                </Typography>
              </Box>
            ) : (
              <Box display='flex'>
                <Typography
                  variant='h2'
                  sx={{ marginBottom: theme.spacing(1) }}>
                  {t('noSearchResultWithQuery')}
                </Typography>
                <Typography variant='h2' sx={{ fontWeight: 'bold' }}>
                  &nbsp;&quot;{query}&quot;
                </Typography>
              </Box>
            )}
          </Box>
          {!hasListItems && (
            <Typography variant='body1'>{t('noSearchResults')}</Typography>
          )}
        </Box>
      )}
    </Box>
  )
}
